import { useDispatch, useSelector } from "react-redux";
import { _t, i18n } from "app/i18n/i18n";
import { useState } from "react";
import useCookie from "react-use-cookie";
import { Button, Image, Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faBookOpen } from "@fortawesome/free-solid-svg-icons";
import {
  REDESIGN_REMINDER,
  REDESIGN_MODAL,
  REDESIGN,
  REDESIGN_MODAL_REMIND_LATER,
} from "redux/slices/api/initialisePreferences";
import Modal from "lib/Modal/Modal";
import List from "lib/List/List";
import { isMobile } from "lib/hooks/useIsMobile";
import { setPreference, setShallowPreference } from "pages/preferences/preferencesActions";
import { switchDesign } from "pages/preferences/parts/switchDesign";
import "./NewDesignModal.scss";
import { isPublicPath } from "../routing";

function NewDesignModal() {
  const dispatch = useDispatch();
  const [, setDissmissed] = useCookie(REDESIGN_REMINDER);
  const [isImageLoading, setImageLoading] = useState(true);
  const visibility = useSelector((state) => state.preferences[REDESIGN_MODAL])[0];
  const modalReminder = useSelector((state) => state.preferences[REDESIGN_MODAL_REMIND_LATER])[0];
  const isVisible = visibility === "true" || visibility === true;
  const isModalReminderOn = modalReminder === "true" || modalReminder === true;
  const isNewDesign = useSelector((state) => state.preferences[REDESIGN])[0] === "New";
  const { path } = useSelector((state) => state.filter);
  const shouldShowOnPage = !path.includes("/advert2/preview");
  const cookieExpiry = { days: 3 };
  const lang = i18n.getLanguage();
  const imageSrcs = {
    en: `https://researchcdn.nomuranow.com/01/p/ns/images/NewUI_En.png`,
    ja: `https://researchcdn.nomuranow.com/01/p/ns/images/NewUI_Ja.png`,
  };
  const learnMoreUrl = `/research/japi/content/assets/static/New%20GRP%20UI%20-%20Highlights_${lang}.pdf`;
  const imageSrc = imageSrcs[lang];
  const bottomSectionStyle = `bottom-section ${isMobile() && "bottom-section-multi"}`;
  const disclaimerStyle = `disclaimer ${isMobile() && "disclaimer-multi"}`;

  const setVisible = (value) => {
    dispatch(setShallowPreference({ key: REDESIGN_MODAL, value }));
  };
  const remindLater = () => {
    setDissmissed(true, cookieExpiry);
    dispatch(setPreference({ key: REDESIGN_MODAL_REMIND_LATER, value: true }));
    setVisible(false);
  };
  const switchToNewDesign = () => {
    setVisible(false);
    setDissmissed(true, cookieExpiry);
    dispatch(setPreference({ key: REDESIGN, value: "New" }));
    switchDesign("New");
  };
  const finalImageStyle = {
    visibility: isImageLoading ? "hidden" : "visible",
  };

  if (isPublicPath()) {
    return null;
  }

  return isModalReminderOn || isNewDesign ? null : (
    <Modal
      visible={isVisible && shouldShowOnPage}
      headerTitle={_t("Switch to the New GRP Design")}
      onClickModalHeader={() => setVisible(false)}
      footerLeftButton={
        <Button variant="secondary" onClick={remindLater} className="footer-button">
          {_t("Remind me later")}
        </Button>
      }
      footerRightButton={
        <Button variant="primary" onClick={switchToNewDesign} className="footer-button">
          {_t("Switch to New Design")}
        </Button>
      }
    >
      <p className="description">{_t("A new portal interface with easier navigation and a more powerful search.")}</p>
      {!isMobile() ? (
        <div className="image-container">
          {isImageLoading && <Spinner animation="grow" variant="primary" />}

          <Image
            src={imageSrc}
            fluid
            style={finalImageStyle}
            className="image"
            onLoad={() => {
              setImageLoading(false);
            }}
          />
        </div>
      ) : (
        <div>
          <List
            iconName={faCheck}
            listItems={[_t("One click navigation"), _t("Left-hand side filters"), _t("Enhanced top menu")]}
          />
        </div>
      )}
      <div className={bottomSectionStyle}>
        <p className={disclaimerStyle}>
          {_t("**Please note that some of the saved bookmarks may not work and will need to resaved.")}
          <br />
          {_t("Disclaimer2_Ja")}{" "}
        </p>
        <a href={learnMoreUrl} target="_blank" className="link" rel="noreferrer">
          <FontAwesomeIcon icon={faBookOpen} className="icon" />
          {_t("Learn more about the features")}
        </a>
      </div>
    </Modal>
  );
}

export default NewDesignModal;
